/**
 * Workspace widget feature-flag combinations (chat-service parity).
 */

export const WIDGET_COMBOS = {
  BOT_ONLY: { id: 5, label: "Chatbot only", c: true, h: false, t: false },
  BOT_HUMAN: { id: 1, label: "Chatbot + human agents", c: true, h: true, t: false },
  BOT_TICKET: { id: 3, label: "Chatbot + tickets", c: true, h: false, t: true },
  BOT_HUMAN_TICKET: { id: 4, label: "Chatbot + human + tickets", c: true, h: true, t: true },
  HUMAN_ONLY: { id: 2, label: "Human agents only", c: false, h: true, t: false },
  HUMAN_TICKET: { id: 6, label: "Human agents + tickets", c: false, h: true, t: true },
};

export function flagsFromState({ enableChatbot, enableHumanAgents, enableTicketSystemIntegration }) {
  return {
    enable_chatbot: Boolean(enableChatbot),
    enable_human_agents: Boolean(enableHumanAgents),
    enable_ticket_system_integration: Boolean(enableTicketSystemIntegration),
  };
}

export function resolveWidgetCombo(flags) {
  const c = flags.enable_chatbot;
  const h = flags.enable_human_agents;
  const t = flags.enable_ticket_system_integration;
  if (c && h && t) return WIDGET_COMBOS.BOT_HUMAN_TICKET;
  if (c && h && !t) return WIDGET_COMBOS.BOT_HUMAN;
  if (!c && h && !t) return WIDGET_COMBOS.HUMAN_ONLY;
  if (!c && h && t) return WIDGET_COMBOS.HUMAN_TICKET;
  if (c && !h && t) return WIDGET_COMBOS.BOT_TICKET;
  if (c && !h && !t) return WIDGET_COMBOS.BOT_ONLY;
  return null;
}

/** @returns {string|null} Error message or null if valid */
export function validateWidgetFlags(flags) {
  const c = flags.enable_chatbot;
  const h = flags.enable_human_agents;
  const t = flags.enable_ticket_system_integration;
  if (t && !c && !h) {
    return "Ticket system integration requires chatbot or human agents to be enabled.";
  }
  if (!c && !h && !t) {
    return "At least one setting must be enabled.";
  }
  return null;
}

export function describeActiveCombo(state) {
  const flags = flagsFromState(state);
  const combo = resolveWidgetCombo(flags);
  if (combo) return combo.label;
  const err = validateWidgetFlags(flags);
  return err ? `Invalid: ${err}` : "Unknown combination";
}

/** @param {number} comboId @param {number[]} allowedIds */
export function isComboAllowed(comboId, allowedIds) {
  if (comboId == null || !Array.isArray(allowedIds)) return false;
  return allowedIds.includes(comboId);
}

/**
 * After a toggle, would the resulting flags resolve to an allowed combo?
 * @returns {string|null} Error message or null if OK
 */
export function validateFlagsAgainstAllowlist(state, allowedIds) {
  const err = validateWidgetFlags(flagsFromState(state));
  if (err) return err;
  const combo = resolveWidgetCombo(flagsFromState(state));
  if (!combo) return "Invalid widget flag combination.";
  if (!isComboAllowed(combo.id, allowedIds)) {
    return "This routing mode is not enabled for your account. Contact your platform administrator.";
  }
  return null;
}
